export default __webpack_public_path__ + "static/media/General-ghost.c6c739a4.png";